
import { computed, defineComponent, ref } from 'vue';
import ChartIcon from '@/components/ui-elements/icons/ChartIcon.vue';
import ChevronDownIcon from '@/components/ui-elements/icons/ChevronDownIcon.vue';
import CloseIcon from '@/components/ui-elements/icons/CloseIcon.vue';
import CogIcon from '@/components/ui-elements/icons/CogIcon.vue';
import HomeIcon from '@/components/ui-elements/icons/HomeIcon.vue';
import MenuIcon from '@/components/ui-elements/icons/MenuIcon.vue';
import ReportsIcon from '@/components/ui-elements/icons/ReportsIcon.vue';
import UserCircleIcon from '@/components/ui-elements/icons/UserCircleIcon.vue';
import Link from '@/components/ui-elements/Link.vue';
import SubNav from '@/components/partials/SubNav.vue';
import SubNavItems from '@/components/partials/SubNavItems.vue';
import { useUserStore } from '@/store';

export default defineComponent({
	components: {
		ChartIcon,
		ChevronDownIcon,
		CloseIcon,
		CogIcon,
		HomeIcon,
		Link,
		MenuIcon,
		ReportsIcon,
		SubNav,
		SubNavItems,
		UserCircleIcon,
	},
	setup() {
		const userStore = useUserStore();
		const buttonSelected = ref(false);
		const showMobileNav = ref(false);
		const showSubNav = ref(false);
		const fullName = computed(
			() => `${userStore.user.first_name} ${userStore.user.last_name}`
		);

		const profileLinks = [
			{ to: { name: 'settings' }, label: 'Settings', icon: 'CogIcon' },
			{ to: { name: 'logout' }, label: 'Logout', icon: 'LogoutIcon' },
		];
		const menu = [
			{ link: { name: 'home' }, label: 'Home', icon: 'HomeIcon' },
			{ link: { name: 'budgets' }, label: 'Budgets', icon: 'ChartIcon' },
			{
				link: { name: 'reports' },
				label: 'Reports',
				icon: 'ReportsIcon',
			},
		];

		const resetSelected = () => {
			showSubNav.value = false;
			buttonSelected.value = false;
		};

		const toggleSelected = () => {
			showSubNav.value = !showSubNav.value;
			buttonSelected.value = !buttonSelected.value;
		};

		return {
			buttonSelected,
			fullName,
			profileLinks,
			showMobileNav,
			showSubNav,
			resetSelected,
			toggleSelected,
			menu,
		};
	},
});
